// pages/Solutions.js - REMOVED BRANDS SECTION
import React from 'react';
import { Link } from 'react-router-dom';
import { Zap, Settings, Sun, Shield, ChevronRight, MapPin, Cpu, Battery, Activity } from 'lucide-react';

const Solutions = () => {
  const businessUnits = [
    {
      icon: Settings,
      title: 'LV Systems',
      slug: 'lv',
      desc: 'Low voltage distribution, VFDs, and MCC panels for commercial and industrial applications.',
      image: '/images/solutions/lv-panel-building.jpg',
      specs: '415V, VFDs, MCCs',
      applications: ['Commercial Buildings', 'Industrial Plants', 'Pump Stations', 'HVAC Systems']
    },
    {
      icon: Zap,
      title: 'MV Systems',
      slug: 'mv',
      desc: 'Medium voltage switchgear and protection systems for industrial and utility applications.',
      image: '/images/solutions/mv-switchgear.jpg',
      specs: '11kV, 33kV',
      applications: ['Substations', 'Industrial Plants', 'Utilities', 'Mining']
    },
    {
      icon: Sun,
      title: 'Solar Energy',
      slug: 'solar',
      desc: 'Residential, commercial, and industrial solar solutions including PV systems, storage, and hybrid installations.',
      image: '/images/solutions/solar-installation.jpg',
      specs: '1kW - 1MW+',
      applications: ['Residential', 'Commercial', 'Industrial', 'Remote Communities']
    },
    {
      icon: Activity,
      title: 'Digital Energy',
      slug: 'digital-energy',
      desc: 'Smart monitoring, power quality meters, and analytics for efficient power management.',
      image: '/images/solutions/digital-energy.jpg',
      specs: 'IoT, Analytics, Power Quality',
      applications: ['Commercial Buildings', 'Data Centers', 'Utilities', 'Hospitals']
    },
    {
      icon: Cpu,
      title: 'Industrial Automation',
      slug: 'automation',
      desc: 'PLC, SCADA, and control systems for complete industrial automation.',
      image: '/images/solutions/automation.jpg',
      specs: 'PLC, SCADA, DCS',
      applications: ['Manufacturing', 'Water Treatment', 'Oil & Gas', 'Food Processing']
    },
    {
      icon: Battery,
      title: 'Backup Power',
      slug: 'backup-power',
      desc: 'UPS, Generators, ATS, and Battery Storage for critical load protection and continuity.',
      image: '/images/solutions/backup-power.jpg',
      specs: 'UPS, Generators, ATS, Batteries',
      applications: ['Data Centers', 'Hospitals', 'Industrial Plants', 'Commercial Buildings']
    }
  ];

  return (
    <div className="pt-20">
      <section className="relative py-16 bg-gradient-to-r from-[#006D77] to-[#008B8B] text-white">
        <div className="container mx-auto px-4 md:px-6 text-center">
          <h1 className="text-4xl md:text-5xl font-bold">Our Solutions</h1>
          <p className="text-lg text-white/80 mt-2 max-w-2xl mx-auto">
            Comprehensive electrical engineering solutions across LV, MV, Solar, Digital Energy, Automation, and Backup Power
          </p>
        </div>
      </section>

      <section className="py-16 bg-gray-50">
        <div className="container mx-auto px-4 md:px-6">
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
            {businessUnits.map((item, idx) => {
              const Icon = item.icon;
              return (
                <div
                  key={idx}
                  className="group bg-white rounded-xl overflow-hidden shadow hover:shadow-lg transition-all hover:-translate-y-1"
                >
                  <div className="h-48 overflow-hidden relative">
                    <img 
                      src={item.image}
                      alt={item.title}
                      className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                      onError={(e) => {
                        e.target.src = `https://picsum.photos/seed/${item.slug}/800/600`;
                      }}
                    />
                    <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-black/20 to-transparent"></div>
                    
                    <div className="absolute top-3 left-3 bg-white/95 backdrop-blur-sm p-2 rounded-lg shadow">
                      <Icon className="w-5 h-5 text-[#006D77]" />
                    </div>
                    
                    <div className="absolute top-3 right-3 bg-[#006D77] text-white px-2 py-1 rounded-full text-xs font-medium">
                      {item.specs.split(',')[0]}
                    </div>

                    <div className="absolute bottom-3 left-3 flex items-center text-white/80 text-xs">
                      <MapPin size={12} className="mr-1" />
                      Kenya & East Africa
                    </div>
                  </div>
                  
                  <div className="p-4">
                    <h3 className="text-lg font-bold text-gray-900 mb-2">{item.title}</h3>
                    <p className="text-gray-600 text-sm leading-relaxed mb-3">{item.desc}</p>

                    {/* Applications - Only, No Brands */}
                    <div className="mb-3">
                      <p className="text-xs font-semibold text-gray-500 uppercase tracking-wider mb-1">Applications</p>
                      <div className="flex flex-wrap gap-1">
                        {item.applications.slice(0, 2).map((app, i) => (
                          <span key={i} className="text-xs bg-gray-100 text-gray-600 px-2 py-0.5 rounded-full">
                            {app}
                          </span>
                        ))}
                        {item.applications.length > 2 && (
                          <span className="text-xs text-gray-400">+{item.applications.length - 2}</span>
                        )}
                      </div>
                    </div>
                    
                    <Link 
                      to={`/solutions/${item.slug}`} 
                      className="inline-flex items-center text-[#006D77] font-medium text-sm hover:gap-1 transition-all"
                    >
                      Learn more 
                      <ChevronRight size={14} className="ml-1" />
                    </Link>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </section>
    </div>
  );
};

export default Solutions;
